var _circle, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInfo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 15,
    cy: 15,
    r: 10.75,
    fill: "#00B67A",
    stroke: "#00B67A"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.5903 12.1318V19H14.4097V12.1318H15.5903ZM14.3208 10.3101C14.3208 10.1196 14.3779 9.95882 14.4922 9.82764C14.6107 9.69645 14.7842 9.63086 15.0127 9.63086C15.237 9.63086 15.4084 9.69645 15.5269 9.82764C15.6496 9.95882 15.7109 10.1196 15.7109 10.3101C15.7109 10.492 15.6496 10.6486 15.5269 10.7798C15.4084 10.9067 15.237 10.9702 15.0127 10.9702C14.7842 10.9702 14.6107 10.9067 14.4922 10.7798C14.3779 10.6486 14.3208 10.492 14.3208 10.3101Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfo);
export default __webpack_public_path__ + "static/media/info.9c6ee9e0b69218e2b8b418cf050ee8b7.svg";
export { ForwardRef as ReactComponent };